export default __webpack_public_path__ + "static/media/Support.541be07e.png";